import { render, staticRenderFns } from "./AngleRightIcon.vue?vue&type=template&id=48197ea6&"
import script from "./AngleRightIcon.vue?vue&type=script&lang=js&"
export * from "./AngleRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports